<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    Please confirm billing before submitting {{ payrollType }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="billingCharges" class="modal-body">
  <div class="row">
    <div class="col m-3">These fees are based on the client’s current billing group.</div>
  </div>
  <div class="m-3">
    <div *ngFor="let billing of billingCharges; let i = index" class="row">
      <div class="col-5">
        <input
          type="radio"
          id="billing-opt-{{ i }}"
          [value]="billing.BillingType"
          [(ngModel)]="selBillingType" />
        <label for="billing-opt-{{ i }}" class="fw-bold"
          ><span></span>{{ billingTypes[billing.BillingType] }}</label
        >
      </div>
      <div class="col-4">
        <span>{{ billing.Amount | currency }}</span>
      </div>
    </div>
    <div
      class="row mt-5"
      *ngIf="payroll.PayType == payTypes.OffCycle || payroll.PayType == payTypes.Adjustment">
      <div class="col">
        <strong>
          <lib-checkbox
            label="Send client notifications summarizing {{ payrollType }} details"
            [(ngModel)]="sendNotification"></lib-checkbox>
        </strong>
      </div>
    </div>
    <div class="d-flex mt-2 justify-content-end">
      <button class="btn btn-secondary" (click)="onDismiss()">Back</button>
      <button class="btn btn-primary ms-3" (click)="save()">Confirm & Continue</button>
    </div>
  </div>
</div>
